import { api } from "../../ConsumeApiController";
import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";

export async function SearchPerson(query) {
    try {
        const url = CompanyRoutes.CRM.Customers.search(query);
        const response = await api.get(url);
        return response;
    } catch (error) {
        return { success: false, message: error.message, data: [] };
    }
}

/*
|--------------------------------------------------------------------------
| CREATE QUICK CUSTOMER
|--------------------------------------------------------------------------
| EN - Creates a new customer via the CRM endpoint.
| ES - Crea un nuevo cliente a través del endpoint de CRM.
*/
export async function CreatePerson(data) {
    try {
        // Apunta a la ruta que definimos en api.php: 
        // Route::prefix('crm')->prefix('customers')->post('/', ...)
        const url = CompanyRoutes.CRM.Customers.create;
        
        // 'data' contiene: { name, last_name, email, phone, create_user }
        const response = await api.post(url, data);
        
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}
